<footer class="page-footer">
  <div class="footer-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-sm-6">
           <p class="mb-0  pt-2 ps-4"> <span>Version: 2.0.14</span><span>, Build: 02-Nov-2026-5:56PM</span> Copyright © <span class="year-update">{{ getCurrentYear() }}</span>
        Etrapp. All rights reserved.</p>
        </div>
      </div>
    </div>
  </div>
</footer>
